import { Remove } from '@mui/icons-material';
import {
  Button,
  FormHelperText,
  Grid,
  IconButton,
  Stack
} from '@mui/material';
import { FieldArray, Form, Formik } from 'formik';
import React from 'react';
import * as Yup from 'yup';
import CustomButton from '../../elements/CustomButton';
import InputField from '../../elements/InputField';

const VideoLinksForm = ({ onSubmit, product }) => {
  return (
    <Formik
      initialValues={{
        link: product?.youtube_links?.length > 0 ? product.youtube_links : [''],
      }}
      validationSchema={Yup.object().shape({
        link: Yup.array().of(Yup.string()).required('Link is required'),
      })}
      onSubmit={onSubmit}>
      {({
        errors,
        handleBlur,
        handleSubmit,
        touched,
        values,
        handleChange,
      }) => (
        <Form noValidate onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Stack spacing={1}>
                <FieldArray
                  name="link"
                  render={(arrayHelpers) => (
                    <div>
                      {values.link.map((point, index) => (
                        <div
                          key={index}
                          style={{ display: 'flex', alignItems: 'center' }}>
                          <InputField
                            id={`link[${index}]`}
                            name={`link[${index}]`}
                            type="text"
                            value={point}
                            multiline
                            onChange={handleChange}
                            fullWidth
                          />
                          <IconButton
                            onClick={() => arrayHelpers.remove(index)}
                            color="secondary"
                            >
                            <Remove />
                          </IconButton>
                        </div>
                      ))}
                      <Stack
                        direction="row"
                        justifyContent="center"
                        spacing={2}>
                        <Button
                          onClick={() => arrayHelpers.push('')}
                          color="primary"
                          variant="text"
                          sx={{ mt: '10px' }}>
                          Add video
                        </Button>
                      </Stack>
                    </div>
                  )}
                />
              </Stack>
            </Grid>
            {errors.submit && (
              <Grid item xs={12}>
                <FormHelperText error>{errors.submit}</FormHelperText>
              </Grid>
            )}
            <Grid item xs={12}>
              <CustomButton />
            </Grid>
          </Grid>
        </Form>
      )}
    </Formik>
  );
};

export default VideoLinksForm;
